module.exports = __webpack_public_path__ + "static/media/cardFive.8b6c8e72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardFive.jpg
// module id = 87
// module chunks = 0